import { useEffect, useState } from 'react';
import axios from '../../../lib/axios';
import moment from 'moment';
import { OrderModel } from '../../../models/order';
import { ADMIN_ORDER_FIND_MANY } from '../../../lib/endpoints/order';
import { OrderStatusEnum } from '../../../enums/orderStatus';
import { convertOrderStatusEnumToStatusCode } from '../../../utils/convertOrderStatusValue';
import { BranchModel } from '../../../models/branch';
import { MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchant';
import { MerChantModel } from '../../../models/merChantModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

interface ReportType {
  totalSale: number;
  completedSale: number;
  partiallyCompletedSale: number;
  returnSale: number;
  failedSale: number;
  customerOrder: number;
  toPackOrder: number;
  toShipOrder: number;
  shippingOrder: number;
}

interface ReturnOrderSummaryType {
  totalOrder: number;
  totalSale: number;
}

export const useHomeController = () => {
  // variables

  const [dataOrderReport, setDataOrderReport] = useState<ReportType>(null!);
  const [data, setData] = useState<OrderModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const todayDate = moment(new Date()).format('DD/MM/yyyy');

  const [openMerchantStore, setOpenMerchantStore] = useState<boolean>(false);
  const [loadingMerchantStoreChange, setLoadingMerchantStoreChange] = useState<boolean>(false);

  const [countProductTotal, setCountProductTotal] = useState<number>(0);
  const [countCategoryTotal, setCountCategoryTotal] = useState<number>(0);

  const [dataBranch, setDataBranch] = useState<MerChantModel[]>([]);

  const roleAdmin = useSelector((state: RootState) => state?.auth?.data?.role?.role_type);
  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);

  // functions

  function filterDataByDate(data: OrderModel[], startDate: Date, endDate: Date): OrderModel[] {
    return data.filter((item) => {
      const updatedAt = new Date(item.updatedAt).setHours(0, 0, 0, 0);
      return (
        updatedAt >= startDate.setHours(0, 0, 0, 0) && updatedAt <= endDate.setHours(0, 0, 0, 0)
      );
    });
  }

  function calculateTotalWithDeliveryFeeSum(orders: OrderModel[]): number {
    return orders.filter((item)=>item?.status?.code===convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)).reduce((sum, order: OrderModel) => sum + order?.totoalWithDeliveryFee, 0);
  }

  const handleGetDataOrder = async () => {
    try {
      // const getTotalSale: number = (await handleGetDataOrderSummary(null!))
      //   .totalSale;
      // const getCompletedSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Delivered)
      // ).totalSale;
      // const getPartillyCompletedSale: number = 0;
      // const getReturnSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Return)
      // ).totalSale;
      // const getFailedSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Failed)
      // ).totalSale;
      // const getCustomerOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Failed)
      // ).totalOrder;
      // const getToPackOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.To_Pack)
      // ).totalOrder;
      // const getToShipOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.To_Ship)
      // ).totalOrder;
      // const getShippingOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Shipping)
      // ).totalOrder;
      const res = await axios.post(`${ADMIN_ORDER_FIND_MANY}`);
      const newData: OrderModel[] = filterDataByDate(res?.data, new Date(), new Date());
      setData(newData);
      setDataOrderReport({
        totalSale: calculateTotalWithDeliveryFeeSum(
          newData?.filter(
            (item) =>
              item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
          )
        ),
        completedSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
        )?.length,
        partiallyCompletedSale: newData?.filter((item)=>item?.updateByAdmin===true)?.length,
        returnSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Return)
        )?.length,
        failedSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Failed)
        )?.length,
        customerOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER)
        )?.length,
        toPackOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack)
        )?.length,
        toShipOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Ship)
        )?.length,
        shippingOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping)
        )?.length,
      });
    } catch (err) {}
  };

  const handleGetDataOrderMerchant = async () => {
    try {
      const res = await axios.post(`${ADMIN_ORDER_FIND_MANY}`);
      const newData: OrderModel[] = filterDataByDate(res?.data, new Date(), new Date());
      setData(newData);
      setDataOrderReport({
        totalSale: calculateTotalWithDeliveryFeeSum(
          newData?.filter(
            (item) =>
              item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
          )
        ),
        completedSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
        )?.length,
        partiallyCompletedSale: 0,
        returnSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Return)
        )?.length,
        failedSale: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Failed)
        )?.length,
        customerOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER)
        )?.length,
        toPackOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack)
        )?.length,
        toShipOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Ship)
        )?.length,
        shippingOrder: newData?.filter(
          (item) =>
            item?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping)
        )?.length,
      });
    } catch (err) {}
  };

  const handleGetDataMerchantStore = async () => {
    try {
      const resBranch = await axios.get(MERCHANT_STORE_FIND_MANY);
      if (resBranch?.data?.length > 0) {
        const matchingMerchants = resBranch?.data.filter((merchant: any) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );
        if (roleAdmin === 'SUPER_ADMIN') {
          setDataBranch(resBranch?.data);
        } else if (roleAdmin === 'ADMIN') {
          if (matchingMerchants.length > 0) {
            setDataBranch(matchingMerchants);
          }
        }
      }
    } catch (err) {
    } finally {
    }
  };

  const handleGetData = async () => {
    try {
      await handleGetDataMerchantStore();
      await handleGetDataOrder();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect
  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    todayDate,
    dataOrderReport,
    dataBranch,
    calculateTotalWithDeliveryFeeSum,
    data,
  };
};
